import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_there_any_restr_to_wrkrs_applying_for_or_taking_leave'

export const dataPointDefinition = {
  retracedId: 'are_there_any_restr_to_wrkrs_applying_for_or_taking_leave',
  name: 'Are there any restrictions to workers applying for or taking leave?',
  description:
    'The intent of this question is to understand if there are any restrictions to workers applying for or taking leave. "Restrictions" refer to scenarios in which workers cannot take legally mandated leave.\r\r\n\r\r\nFor example, if the facility restricts workers\' ability to take leave during peak production or before major holidays, answer Yes.\r\r\n\r\r\nIssues regarding payment for leave are covered separately under WAGES & BENEFITS.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-23--8',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6970,
  sectionId: '2.2.12',
  impactArea: 'Working Hours',
  impactAreaId: 'WORKING_HOURS_AND_OVERTIME',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
